import { render, staticRenderFns } from "./adFourProd.vue?vue&type=template&id=0f573c2d&scoped=true&"
import script from "./adFourProd.vue?vue&type=script&lang=js&"
export * from "./adFourProd.vue?vue&type=script&lang=js&"
import style0 from "./adFourProd.vue?vue&type=style&index=0&id=0f573c2d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f573c2d",
  null
  
)

export default component.exports